import React, { useState, useEffect } from "react";
import {
  useQuery,
  useManualQuery,
  useMutation,
  ClientContext,
} from "graphql-hooks";

import { useParams, Link, useNavigate } from "react-router-dom";

import {
  Grid,
  Checkbox,
  Button,
  Typography,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import update from "immutability-helper";
import { NOTIFY_APPLICANTS_MUTATE, 
         GET_SELECTED_APPLICANTS_BY_TERM_ID_QUERY,
         GET_UN_SELECTED_APPLICANTS_BY_TERM_ID_QUERY} from "../../graphQL/term_applicant_qry";

import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const useStyles = makeStyles((theme) => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
}));

export default function SelectQualifiedApplicantsDialog({ 
  termUuid, 
  applySelections,
  closeDialog,  

}) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [notifiedAll, setNotifiedAll] = useState(false);
  const [textMessage, setTextMesage] = useState('The welcome email to qualified applicants and the rejection email to unqualified applicants have already been sent.');
  const [qualAppsList, setQualAppsList] = useState([])
  const [unQualAppsList, setUnQualAppsList] = useState([])

  const navigate = useNavigate(); 

  const formatter1 = new Intl.DateTimeFormat("en-us", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    fractionalSecondDigits: 3,
    hour12: true,
    timeZoneName: "short",
  });

  const formatter2 = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = (day, format = null) => {
    const dayDate = new Date(day);
    const dayFormat = format!== null 
                      ? 
                        formatter1.formatToParts(dayDate)
                      :
                        formatter2.formatToParts(dayDate)
                      ;    
    if (format === "DDmonthYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "day").value +
        " " +
        dayFormat.find((a) => a.type == "month").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "monthDDYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "YYYYmonthDD"){
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value +
        ", " +
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value;
      return newFormat;
    } else {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        "/" +
        dayFormat.find((a) => a.type == "day").value +
        "/" +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    }
  }; 

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };
  
  const [notifyApplicants] = useMutation(
    NOTIFY_APPLICANTS_MUTATE
  );

  const [fetchQualifiedTermApplicants] = useManualQuery(GET_SELECTED_APPLICANTS_BY_TERM_ID_QUERY, {
    fetchPolicy: "network-only",
  });

  const [fetchUnQualifiedTermApplicants] = useManualQuery(GET_UN_SELECTED_APPLICANTS_BY_TERM_ID_QUERY, {
    fetchPolicy: "network-only",
  });

  const getQualifiedTermApplicants = async () => {
    // Get term applicants information
    const {
          loading: qualifiedTermApplicantsLoading,
          error: qualifiedTermApplicantsError,
          data: qualifiedTermApplicantsData,
        } = await fetchQualifiedTermApplicants({
          variables: { 
            termUuid: termUuid 
          },
    });

    if (
          !qualifiedTermApplicantsLoading &&
          qualifiedTermApplicantsData &&
          qualifiedTermApplicantsData.getSelectedApplicantsByTermId
    ) {                    
                                      
        setQualAppsList(qualifiedTermApplicantsData.getSelectedApplicantsByTermId);
        setNotifiedAll(true);
        qualifiedTermApplicantsData.getSelectedApplicantsByTermId.map((app, index) => {
          if (app.applicantNotified == false)
          {
            setNotifiedAll(false)
            return;
          }
        });        
    } 

    if (
          qualifiedTermApplicantsError &&
          qualifiedTermApplicantsError.graphQLErrors &&
          qualifiedTermApplicantsError.graphQLErrors[0].message ===
            "Signature has expired"
        ) {
          navigate(`${project_url}/signin`);
        }     
      
  };

  
  const getUnQualifiedTermApplicants = async () => {
    // Get term applicants information
    const {
          loading: unQualifiedTermApplicantsLoading,
          error: unQualifiedTermApplicantsError,
          data: unQualifiedTermApplicantsData,
        } = await fetchUnQualifiedTermApplicants({
          variables: { 
            termUuid: termUuid 
          },
    });

    if (
          !unQualifiedTermApplicantsLoading &&
          unQualifiedTermApplicantsData &&
          unQualifiedTermApplicantsData.getUnSelectedApplicantsByTermId
    ) {                    
                                      
        setUnQualAppsList(unQualifiedTermApplicantsData.getUnSelectedApplicantsByTermId);
        setNotifiedAll(true);
        unQualifiedTermApplicantsData.getUnSelectedApplicantsByTermId.map((app, index) => {
          if (app.applicantNotified == false)
          {
            setNotifiedAll(false)
            return;
          }
        });        
    } 

    if (
          unQualifiedTermApplicantsError &&
          unQualifiedTermApplicantsError.graphQLErrors &&
          unQualifiedTermApplicantsError.graphQLErrors[0].message ===
            "Signature has expired"
        ) {
          navigate(`${project_url}/signin`);
        }     
      
  };

  useEffect(() => {
    (() => getQualifiedTermApplicants())();
  }, []);

  useEffect(() => {
    (() => getUnQualifiedTermApplicants())();
  }, []);


   
  const handleApplyNotifications = async() => {
    let qualifiedApplicantIds = [];
    let unQualifiedApplicantIds = [];
    qualAppsList.map((app, index) => {      
      qualifiedApplicantIds.push(parseInt(app.termApplicantId));
    });
    unQualAppsList.map((app, index) => {      
      unQualifiedApplicantIds.push(parseInt(app.termApplicantId));
    });
    
    const { data, error } = await notifyApplicants({
      variables: {
        qualifiedApplicantIds: qualifiedApplicantIds,
        unQualifiedApplicantIds : unQualifiedApplicantIds
      },
    });
    if (error) {
      console.log("Error", error, data);       
    } else {
      console.log("Success in notified applicants"); 
      setTextMesage('The welcome email to qualified applicants and the rejection email to unqualified applicants have been just sent.');
      getQualifiedTermApplicants(); 
      getUnQualifiedTermApplicants();     
    }
  };

  return (
    <div style={{ width: "100%", minWidth: 600}}>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              minWidth: "600px"
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Grid
            container
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Grid
              item
              xs={11}
              style={{
                textAlign: "center",
                paddingLeft: 15,
              }}
            >
              Applicants Notification via Email
            </Grid>
            <Grid item xs={1}>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  align: "right",
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">

            <Grid
              container
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingBottom: 3,
                paddingTop: 7,
              }}
            >
              <Grid item xs={3} style={{ paddingBottom: 10 }}>
                <Typography variant="h2" style={{ color: "black"}}>Applicant Name</Typography>
              </Grid>
              <Grid item xs={4} style={{ textAlign: "center", paddingLeft: 30 }}>
                <Typography variant="h2" style={{ color: "black"}} >Awarded Score</Typography>
              </Grid>
              <Grid item xs={4} style={{ textAlign: "center", paddingLeft: 30 }}>
                <Typography variant="h2" style={{ color: "black"}} >Notified (Date)</Typography>
              </Grid>              
            </Grid>

            <Grid
              container
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingBottom: 4,
                paddingTop: 4,
              }}
            >
              <Grid item xs={12} style={{ textAlign: "center" }}>
                <Typography style={{ color: "black" , fontSize: "17px"}}>
                  Qualified Applicants 
                </Typography>
              </Grid>              
            </Grid>
            {qualAppsList.length === 0 ?
             (
                <Grid
                container
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingBottom: 4,
                  paddingTop: 4,
                }}
              >
                <Grid item xs={12} style={{ textAlign: "Left" }}>
                  <Typography style={{ color: "black" , fontSize: "15px"}}>
                    No Qualified Applicant 
                  </Typography>
                </Grid>              
              </Grid>
             )
             :
             ( 
              <>
                {qualAppsList.map((item, index) => (
                  <Grid
                    container
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      
                    }}
                  >
                    <Grid item xs={3}>
                      {item.applicantId.userId.firstName} {item.applicantId.userId.lastName}
                    </Grid>
                    <Grid item xs={4} style={{ textAlign: "center", paddingLeft: 30 }}>
                      {item.totalAwardedScore}
                    </Grid>
                    <Grid item xs={4} style={{ textAlign: "center", paddingLeft: 30 }}>
                      {item.applicantNotified ? "Yes" : "No"}
                      {item.applicantNotifiedDate ? 
                        " (" + dayFormat(item.applicantNotifiedDate.substring(0, 10)) + ")" : ""}
                    </Grid>
                  </Grid>
                ))}
              </>
              )}

            <Grid
              container
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingBottom: 4,
                paddingTop: 4,
              }}
            >
              <Grid item xs={12} style={{ textAlign: "center" }}>
                <Typography style={{ color: "black" , fontSize: "17px"}}>
                  Unqualified Applicants 
                </Typography>
              </Grid>              
            </Grid>

            {unQualAppsList.length === 0 ?
             (
                <Grid
                container
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingBottom: 4,
                  paddingTop: 4,
                }}
              >
                <Grid item xs={12} style={{ textAlign: "Left" }}>
                  <Typography style={{ color: "black" , fontSize: "15px"}}>
                    No Unqualified Applicant 
                  </Typography>
                </Grid>              
              </Grid>
             )
             :
             ( 
              <>

                  {unQualAppsList.map((item, index) => (
                    <Grid
                      container
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        paddingBottom: 5,
                      }}
                    >
                      <Grid item xs={3}>
                        {item.applicantId.userId.firstName} {item.applicantId.userId.lastName}
                      </Grid>
                      <Grid item xs={4} style={{ textAlign: "center", paddingLeft: 30 }}>
                        {item.totalAwardedScore}
                      </Grid>
                      <Grid item xs={4} style={{ textAlign: "center", paddingLeft: 30 }}>
                        {item.applicantNotified ? "Yes" : "No"}
                        {item.applicantNotifiedDate ? 
                          " (" + dayFormat(item.applicantNotifiedDate.substring(0, 10)) + ")" : ""}
                      </Grid>
                    </Grid>
                  ))}
              </>
              )}

          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
         { !notifiedAll ? 
          (
              <Box mb={2}>
                <Button
                  variant="contained"
                  color="primary"              
                  className={classes.buttonStyle}
                  style={{ marginRight: 5, width: "170px" }}
                  onClick={handleApplyNotifications}
                  title="You are about to send welcome email to qualified applicants and rejection letter to unqualified applicants."
                >
                  Notify All Applicants
                </Button>
                <Button
                  variant="text"
                  color="primary"
                  className={classes.outlinedButtonStyle}
                  onClick={handleClose}
                >
                  Cancel
                </Button>
              </Box>
          )
          :
          (
             
            <Box mb={2} style={{padding: 15 }}>
              <Typography style={{ justifyContent: "center" }} variant="h3"> 
                {textMessage} 
              </Typography>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>                
                <Button variant="contained"   color="primary"              
                      className={classes.buttonStyle}
                      style={{ marginTop:15 }}
                      onClick={handleClose} >  OK   </Button>                
              </div>
            </Box>            
          )
        }
        </DialogActions>
      </Dialog>
    </div>
  );
}

